import React from "react";
import TextField from "@material-ui/core/TextField";
import PropTypes from "prop-types";

const TrafficSourceFilterSelections = ({
  selectionAddActions,
  filterValues,
  handleSearch
}) => {
  const { handleQueryChange } = selectionAddActions;

  const { query } = filterValues;

  return (
    <div className="TrafficSource-filter__selections">
      <TextField
        variant="standard"
        margin="normal"
        label="Search for Query"
        onChange={handleQueryChange}
        onKeyPress={(e) => {
          e.key === "Enter" && handleSearch();
        }}
        value={query}
        fullWidth
      />
    </div>
  );
};

TrafficSourceFilterSelections.propTypes = {
  selectionAddActions: PropTypes.object.isRequired,
  filterValues: PropTypes.object.isRequired,
  handleSearch: PropTypes.func.isRequired
};

export default TrafficSourceFilterSelections;
